import axios from 'axios';
import { ENTRYPOINT } from '../config/entrypoint';
import { API_ROUTES } from '../constants/api_routes';
import { getHeaders } from '../http/request';
import { USER_ACTION_TYPES } from '../store/actions/user/user_action';
import { setAccessToken, setRefreshToken, getRefreshToken} from './local_storage_service';
import { TOKEN_TYPE } from '../constants/constants';
import { REACT_ROUTES } from '../constants/react_routes';
import history from './history';

axios.interceptors.response.use((response => response), ((error) => error.response));

const SIGN_UP_URL = `${ENTRYPOINT}${API_ROUTES.USERS}`;
const SIGN_IN_URL = `${ENTRYPOINT}${API_ROUTES.AUTHENTICATION_TOKEN}`;

export const signUpUser = async (data) => axios.post(SIGN_UP_URL, data, getHeaders());

export const signInUser = (data) => (
    async (dispatch) => {
        const response = await axios.post(SIGN_IN_URL, data);
        const { token, refresh_token } = response.data;
        if (token && refresh_token) {
            setAccessToken(token);
            setRefreshToken(refresh_token);
            dispatch({
                type: USER_ACTION_TYPES.SIGN_IN_AUTHENTICATE_USER,
                payload: response.data
            });
            return history.push(REACT_ROUTES.SCHEDULER);
        }
        return response;
    }
);

export const refreshUser = async () => {
	const REFRESH_USER_URL = `${ENTRYPOINT}${API_ROUTES.REFRESH_TOKEN}`;
	const data = { refresh_token: getRefreshToken() };
    const response = await axios.post(
        REFRESH_USER_URL,
        data,
        getHeaders(TOKEN_TYPE.REFRESH_TOKEN)
    );
    const { token, refresh_token } = response.data;
    if (token && refresh_token) {
        setAccessToken(token);
        setRefreshToken(refresh_token);
        return token;
    }
};
